<template>
	<div @scroll="scroll" class="list">
		<ul class="qjc-flex">
			<template v-for="item in list">
				<li :key="item.id" @click="$router.push('/dayu/course/detail/'+item.id)" class="qjc-clearfix">
					<div class="left qjc-flex item-top">
						<dl class="left-b">
							<dt class="qjc-fts-32">{{ item.name }}</dt>
							<dd class="qjc-fts-24">适用人群：{{ item.suitableCrowd }}</dd>
						</dl>
						<div class="right qjc-fts-28 qjc-fr">
							<span v-if="item.beginDay > 0">{{ item.beginDay }}天后开始</span>
							<span v-else-if="item.beginDay == 0">正在进行</span>
							<span v-else class="end">已结束</span>
						</div>
					</div>
					<div class="left ">
						<div class=" qjc-flex item-bottom">
							<div class="surname">{{ item.doctors[0].name ? item.doctors[0].name.substring(0, 1) : '' }}</div>
							<!-- <img class="head" :src="item.doctors[0].avatar" :alt="item.doctors[0].name"> -->
							<dl>
								<dt class="qjc-fts-28">{{ item.doctors[0].name }}</dt>
								<dd class="qjc-fts-24">{{ item.doctors[0].title }}</dd>
							</dl>
						</div>
					</div>
				</li>
			</template>
		</ul>
		
		<div v-if="isLoding" class="loading qjc-fixed qjc-texta-c">
			<img src="../../../assets/images/dayu_loding.png" alt="加载中">
			<p>正在努力加载...</p>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import { Toast } from 'vant'
	Vue.use(Toast);
	
	import { courseList } from "@/utils/axios"
	
	export default{
		name: "dayuCourse",
		data() {
			return {
				page: 1,// 默认第一页
				size: 6,// 每页6条
				pages: 0,// 总页数
				
				list: [],
				
				isLoding: true,
			}
		},
		mounted() {
			this.getList();
		},
		methods: {
			// 滚动最底部加载
			scroll(e) {
				var target = e.target;
				if(this.page < this.pages){
					// 5误差
					if((target.clientHeight + target.scrollTop) >= (target.scrollHeight - 5)){
						this.isLoding = true;
						this.page += 1;
						this.getList();
					}
				}
			},
			
			getList() {
				var that = this;
				
				courseList(this.page, this.size).then(res => {
					// console.log(res)
					
					if(res.errno == 0){
						that.list = that.list.concat(res.data.records);
						that.pages = res.data.pages;
					}else{
						Toast.fail(res.errmsg);
					}
					
					this.isLoding = false;
					
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.list{
		height: 9.9rem;
		background: url(https://meidn-image.oss-cn-beijing.aliyuncs.com/file/2020/home_bg.png) no-repeat;
		background-size: 100% 100%;
		overflow-y: auto;
		
		.item-top {
			padding-bottom: 0.3rem;
			border-bottom: 1px solid #4A88C6;
		}
		
		.item-bottom {
			margin-top: 0.3rem;
			align-items: center;
		}
		
		.surname {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 0.56rem;
			height: 0.56rem;
			font-size: 0.32rem;
			font-family: SourceHanSansCN-Medium, SourceHanSansCN;
			// font-weight: 500;
			color: #5FD6FF;
			background-color: rgba(255, 255, 255, 0.2);
			border-radius: 50%;
			margin-right: 0.12rem;
		}
		
		&>ul{
			justify-content: center;
			align-items: center;
			flex-wrap: wrap;
			margin: 0 auto;
			padding: 0.4rem 0 0.4rem;
			
			li{
				width: 8.68rem;
				height: 2.82rem;
				margin: 0 0.12rem 0.24rem;
				border-radius: 0.08rem;
				background-color: #0C2841;
				border: 0.01rem solid #4A88C6;
				box-shadow: 0 0 0.2rem 0 inset #3D72A7;
				padding: 0.4rem;
				
				.left{
					
					justify-content: space-between;
					.head{
						width: 0.96rem;
						height: 0.96rem;
						margin-right: 0.16rem;
					}
					dt{
						color: #E1E7F5;
						font-weight: 400;
						line-height: 0.36rem;
						margin-bottom: 0.08rem;
					}
					dd{
						color: #6C6F75;
						line-height: 0.24rem;
					}
					
					.left-t{
						justify-content: flex-start;
						vertical-align: middle;
						margin-bottom: 0.34rem;
						
						dt{
							padding-top: 0.14rem;
						}
					}
				}
				.right{
					color: #3CD1FF;
					
					.end{
						color: #B3B8C2;
					}
				}
				
			}
		}
	
		.loading{
			top: 50%;
			left: 50%;
			font-size: 0.24rem;
			line-height: 0.24rem;
			color: #5FD6FF;
			transform: translate(-50%, -50%);
			z-index: 999;
			
			img{
				width: 0.96rem;
				height: 0.96rem;
				animation: spin 1.5s linear infinite;
			}
			@keyframes spin{
				from{
					transform: rotateZ(0deg);
				}
				to{
					transform: rotateZ(360deg);
				}
			}
		}
	}
</style>
